import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { SubMenuHandlerService } from '@shared/services/subMenuHandler.service';

export interface SubMenuItem {
	icon: () => string;
	text: () => string;
	click: () => void;
	disabled?: () => boolean;
	tooltip?: () => string;
	hideOnDisable?: () => boolean;
	permissions?: () => string[];
	noText?: () => boolean;
	disableOnMissingPermissions?: () => boolean;
}

const menuKey = 'subMenu';
@Component({
	selector: 'header-sub-menu',
	templateUrl: './header-sub-menu.component.html',
	styleUrls: ['./header-sub-menu.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class HeaderSubMenuComponent implements OnChanges, OnDestroy {
	@Input()
	public favoriteItems: SubMenuItem[];

	@Input()
	public menuItems: SubMenuItem[];

	@Input()
	public noInlineText = false;

	@Input()
	public size: 'small' | 'medium' | 'large' = 'small';

	public constructor(public itemsHandlerService: SubMenuHandlerService) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['favoriteItems'] && this.favoriteItems) {
			this.itemsHandlerService.setFavoriteItem(menuKey, this.favoriteItems, true);
		}
		if (changes['menuItems'] && this.menuItems) {
			this.itemsHandlerService.setMenuItem(menuKey, this.menuItems, true);
		}
	}

	ngOnDestroy(): void {
		this.itemsHandlerService.removeFavoriteItems(menuKey);
		this.itemsHandlerService.removeMenuItems(menuKey);
	}

	public HandleClick(item: SubMenuItem) {
		if (item.disabled?.()) return;

		item.click();
	}

	public getTooltip(item: SubMenuItem, isFavorite: boolean): string {
		if (!this.noInlineText) return item.tooltip?.() ?? '';

		if (!isFavorite) {
			if (item.disabled?.()) return item.tooltip?.() ?? '';
		} else if (item.disabled?.()) {
			return item.tooltip?.() ?? '';
		} else {
			return item.text();
		}

		return '';
	}
}
